/**
 * Trending Block
 * Shows algorithmically trending series with tabs
 */
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Star } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { ScrollContainer, SectionHeader, SeriesCardHorizontal } from './shared';

const TrendingBlock = ({ 
  data = { trending: [], popular: [] }, 
  settings = {} 
}) => {
  const trendingRef = useRef(null);
  const popularRef = useRef(null);
  
  const {
    title = 'Trending & Popular Series',
    show_rank = true,
    max_items = 10,
    card_scale = 1.0,
    max_image_height = 280,
  } = settings;

  const trendingSeries = data.trending || [];
  const popularSeries = data.popular || [];

  if (trendingSeries.length === 0 && popularSeries.length === 0) return null;

  return (
    <section data-testid="trending-block">
      <SectionHeader 
        title={title} 
        viewAllLink="/browse" 
      />

      <Tabs defaultValue="trending" className="w-full px-2 sm:px-6">
        <TabsList className="bg-gray-900 border border-gray-800 mb-3 sm:mb-6 h-8 sm:h-10">
          <TabsTrigger value="trending" className="data-[state=active]:bg-orange-500 text-xs sm:text-base px-2 sm:px-4">
            <TrendingUp className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Trending
          </TabsTrigger>
          <TabsTrigger value="popular" className="data-[state=active]:bg-orange-500 text-xs sm:text-base px-2 sm:px-4">
            <Star className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Popular
          </TabsTrigger>
        </TabsList>

        <TabsContent value="trending">
          <ScrollContainer scrollRef={trendingRef}>
            {trendingSeries.slice(0, max_items).map((series, index) => (
              <SeriesCardHorizontal 
                key={series.id} 
                series={series} 
                rank={show_rank ? index + 1 : null}
                trending
                settings={{ card_scale, max_image_height, show_rank }}
              />
            ))}
          </ScrollContainer>
        </TabsContent>

        <TabsContent value="popular">
          <ScrollContainer scrollRef={popularRef}>
            {popularSeries.slice(0, max_items).map((series, index) => (
              <SeriesCardHorizontal 
                key={series.id} 
                series={series} 
                rank={show_rank ? index + 1 : null}
                settings={{ card_scale, max_image_height, show_rank }}
              />
            ))}
          </ScrollContainer>
        </TabsContent>
      </Tabs>
    </section>
  );
};

export default TrendingBlock;
